module.exports = __webpack_public_path__ + "img/impa.7b7ca8fb.png";